export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid="terms-page">
      <div className="text-xs uppercase tracking-widest text-gold-700 font-mono mb-3">Juridique</div>
      <h1 className="font-display text-4xl md:text-5xl text-ink-900">Conditions générales</h1>
      <p className="text-muted2 mt-3">Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}</p>

      <div className="bg-danger/10 border border-danger/40 rounded-xl p-5 mt-8 text-danger text-sm font-medium" data-testid="terms-medical-disclaimer">
        <strong className="uppercase tracking-widest text-xs block mb-1">Avertissement médical important</strong>
        Les certifications E.C.S de la catégorie <em>Médical & Sciences de la Santé</em> constituent des connaissances théoriques à visée strictement éducative. Elles ne confèrent AUCUNE qualification médicale officielle et ne remplacent EN AUCUN CAS un diplôme de médecin, infirmier, pharmacien ou tout autre professionnel de santé agréé. Ne prenez jamais de décision médicale sur la base de ces certifications.
      </div>

      <div className="mt-10 space-y-8 text-ink-700 text-sm leading-relaxed">
        <section>
          <h2 className="font-display text-2xl text-gold-700 mb-2">1. Nature des certificats</h2>
          <p>Les certificats délivrés par E.C.S sont des <strong className="text-ink-900">certifications privées de connaissances</strong>. Ils attestent qu'un apprenant a suivi et validé un parcours pédagogique interne à la plateforme.</p>
          <ul className="list-disc list-inside mt-2 space-y-1 text-muted2">
            <li>Ils ne constituent PAS un diplôme d'État reconnu</li>
            <li>Ils ne constituent PAS une qualification médicale, juridique ou financière officielle</li>
            <li>Ils ne confèrent aucun droit d'exercer une profession réglementée</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display text-2xl text-gold-700 mb-2">2. Politique de remboursement</h2>
          <p>Remboursement intégral sous 48h après achat, à condition de n'avoir ouvert aucune leçon du parcours. Passé ce délai ou en cas d'ouverture d'une leçon, l'accès étant illimité à vie, le remboursement n'est plus possible.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-gold-700 mb-2">3. Règles anti-triche</h2>
          <p>Les tentatives de fraude aux quiz (changements d'onglet répétés, copie-collage, contenu externe) sont automatiquement détectées et signalées. En cas de fraude avérée, E.C.S se réserve le droit d'invalider le certificat sans remboursement.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-gold-700 mb-2">4. Règles de passage des quiz</h2>
          <p>Chaque quiz peut être tenté jusqu'à <strong className="text-gold-700">3 fois maximum</strong>. Au-delà, un verrouillage de 7 jours s'applique. Score de validation : <strong className="text-gold-700">70%</strong>.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-gold-700 mb-2">5. Propriété intellectuelle</h2>
          <p>L'intégralité des contenus (leçons, vidéos, questions, illustrations) est la propriété exclusive d'E.C.S. Toute reproduction, redistribution ou utilisation à des fins commerciales est strictement interdite sans autorisation écrite préalable.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-gold-700 mb-2">6. Compte utilisateur</h2>
          <p>Les mineurs doivent disposer d'un consentement parental. Le compte est strictement personnel — le partage d'accès est interdit et peut entraîner sa suspension immédiate.</p>
        </section>
      </div>
    </div>
  );
}
